import { styled } from '@linaria/react'
import React, { FC, PropsWithChildren } from 'react'
import { useAppContext } from '../contexts/App.context'
import { useNavigate } from 'react-router'
import { indexPagePath } from '../pages/IndexPage'
import { WalletConnectionRequiredDialog } from '../dialogs/WalletConnectionRequiredDialog'

export const CreateBoxLayout: FC<PropsWithChildren> = ({ children }) => {
  const { wallet } = useAppContext()
  const navigate = useNavigate()

  if (!wallet) {
    return (
      <PollsLayoutContainer>
        <WalletConnectionRequiredDialog
          onClose={() => {
            navigate(indexPagePath)
          }}
        />
      </PollsLayoutContainer>
    )
  }

  return <PollsLayoutContainer>{children}</PollsLayoutContainer>
}

const PollsLayoutContainer = styled.div`
  width: 100wh;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  grid-gap: 16px;
  padding-bottom: 16px;
`
